import ProfileEdit from '../../../../../components/Profile/ProfileEdit';
import i18next from 'i18next';
import PasswordChange from '../../../../../components/Profile/PasswordChange';

const PROFILE_ROUTE_EDIT = {
  path: '/profile/edit',
  exact: true,
  additional: {
    component: ProfileEdit,
    protected: true,
    title: i18next.t('titles:editProfile'),
  },
};

const PROFILE_ROUTE_CHANGE_PASSWORD = {
  path: '/change-password',
  exact: true,
  additional: {
    component: PasswordChange,
    protected: true,
    title: i18next.t('titles:changePassword'),
  },
};

export const PROFILE_ROUTES = {
  // ------- For current accounts ------
  edit: PROFILE_ROUTE_EDIT,
  changePassword: PROFILE_ROUTE_CHANGE_PASSWORD,
};

